import * as React from "react";
import { useEffect } from "react";

import { Link } from "../Link";
import { useWindowCommunicationProvider } from "./hooks";

interface IWindowCommunicationLinkProps {
  children: React.ReactNode,
  url: string,
  name?: string,
  onClose: () => void
}

export function WindowCommunication(): JSX.Element {
  return <></>;
}

export function WindowCommunicationLink({
                                          children,
                                          url,
                                          onClose,
                                          name: nameProp
                                        }: IWindowCommunicationLinkProps): JSX.Element {

  const name = nameProp || url;
  const { closed, open } = useWindowCommunicationProvider(url, name);

  useEffect(() => {
    if (closed) {
      onClose();
    }
  }, [closed]);

  return <Link onClick={open}>
    {children}
  </Link>;
}
